import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';

import FormInput from 'components/FormInput/FormInput';
import Button from 'components/Button/Button';
import Heading from 'components/Heading/Heading';
import FormSelection from 'components/FormSelection/FormSelection';
import FormPhoneNumber from 'components/FormPhoneNumber/FormPhoneNumber';

import { useFetchConstant } from 'utils/hooks/general';

const StyledForm = styled(Form)`
  padding: 8% 4% !important;
  width: 100%;

  @media (min-width: 992px) {
    padding: 4% 8% !important;
    width: 68%;
  }
`;

const HostRegistrationForm = ({ form, className, values, onBack, onSave }) => {
  const { selections: countryPhoneCodeSelections } = useFetchConstant('countries', 'Error while getting countries.', 'phoneCode', 'phoneCode');
  const { selections: countrySelections } = useFetchConstant('countries', 'Error while getting countries.', 'iso2', 'name');
  const { selections: stateSelections } = useFetchConstant('statesMY');

  const handleOnNext = e => {
    e.preventDefault();

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onSave(values);
      }
    });
  };

  return (
    <StyledForm>
      <Row>
        <Heading style={{ textAlign: 'center' }} size="sub">
          Let's get started!
        </Heading>
        <Heading style={{ textAlign: 'center' }} size="sub">
          Tell us more about you.
        </Heading>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormInput
            form={form}
            name="firstName"
            label="First Name"
            placeholder="First Name"
            size="large"
            requiredErrorMessage="Please enter your first name."
            defaultValue={values.firstName}
          />
        </Col>
        <Col span={12}>
          <FormInput
            form={form}
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
            size="large"
            requiredErrorMessage="Please enter your last name."
            defaultValue={values.lastName}
          />
        </Col>
      </Row>
      <Row>
        <FormInput form={form} name="companyName" label="Company Name" placeholder="Company Name" size="large" defaultValue={values.companyName} />
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormInput
            form={form}
            name="email"
            label="Email"
            placeholder="email@example.com"
            size="large"
            requiredErrorMessage="Please enter your email."
            extraRules={[
              {
                pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$',
                message: 'Please enter a valid email address.'
              }
            ]}
            defaultValue={values.email}
          />
        </Col>
        <Col span={12}>
          <FormPhoneNumber form={form} countryPhoneCodeSelections={countryPhoneCodeSelections} defaultValues={values} />
        </Col>
      </Row>
      <Row>
        <FormInput
          form={form}
          name="streetAddress"
          label="Address"
          placeholder="Street Address"
          size="large"
          requiredErrorMessage="Please enter your address."
          defaultValue={values.streetAddress}
        />
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormInput
            form={form}
            name="city"
            label="City"
            placeholder="Kuala Lumpur"
            size="large"
            requiredErrorMessage="Please enter your city."
            defaultValue={values.city}
          />
        </Col>
        <Col span={12}>
          <FormInput
            form={form}
            name="zipcode"
            label="ZIP Code"
            placeholder="ZIP Code"
            size="large"
            requiredErrorMessage="Please enter your ZIP Code."
            extraRules={[
              {
                max: 6,
                message: 'ZIP Code has maximum 6 numbers'
              },
              {
                min: 5,
                message: 'ZIP Code has minimum 5 numbers'
              },
              {
                pattern: /^[0-9]*$/,
                message: 'ZIP Code must be number'
              }
            ]}
            defaultValue={values.zipcode}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <FormSelection
            form={form}
            name="country"
            label="Country"
            placeholder="Malaysia"
            size="large"
            selections={countrySelections}
            requiredErrorMessage="Please tell us what's your country."
            defaultValue={values.country}
          />
        </Col>
        <Col span={12}>
          <FormSelection
            form={form}
            name="state"
            label="State"
            size="large"
            placeholder="Selangor"
            selections={stateSelections}
            requiredErrorMessage="Please tell us what's your state."
            defaultValue={values.state}
          />
        </Col>
      </Row>
      <Row type="flex" justify="space-between">
        <Col span={6}>
          <Button onClick={onBack} size="large" style={{ width: '100%', marginTop: '24px' }} type="secondary">
            Home
          </Button>
        </Col>
        <Col span={6}>
          <Button onClick={handleOnNext} size="large" style={{ width: '100%', marginTop: '24px' }} type="primary">
            Next
          </Button>
        </Col>
      </Row>
    </StyledForm>
  );
};

HostRegistrationForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  values: PropTypes.object,
  onBack: PropTypes.func
};

HostRegistrationForm.defaultProps = {
  values: {}
};

export default withRouter(Form.create()(HostRegistrationForm));
